query UsersByScope($scope: InputUserScope!) {
    usersByScope(scope: $scope) {
        id
        role {
            _id
            name
        }
        scope {
            client
            campaign
        }
    }
}
